import { useParams } from 'react-router-dom';
import { getTranslate } from '../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../utils/getLocatPath/getLocalPath';
import { ErrorState } from '../../components/blocks/errorState/ErrorState';
import { PageMetaData } from '../../components/providers/pageMetaData/pageMetaData';
import stytel from './404.module.scss';

export const Error = () => {
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const title = t('Ой! Бет табылмады.', 'Упс! Страница не найдена.', lang);
  const message = t(
    'Бұл бет жойылған немесе ешқашан болмаған сияқты.',
    'Похоже, эта страница была удалена или никогда не существовала.',
    lang,
  );
  const linkText = t('Негізгі бет', 'Главную страницу', lang);
  const linkUrl = l('', lang);
  const seo = {
    title: {
      kz: 'Ой! Бет табылмады.',
      ru: 'Упс! Страница не найдена.',
    },
    description: {
      kz: 'Бұл бет жойылған немесе ешқашан болмаған сияқты.',
      ru: 'Похоже, эта страница была удалена или никогда не существовала.',
    },
  };

  return (
    <>
      <PageMetaData seo={seo} />
      <main className="main padding-header">
        <ErrorState title={title} message={message} linkText={linkText} linkUrl={linkUrl} />
      </main>
    </>
  );
};
